export default __webpack_public_path__ + "static/media/big-dipper.304a0d4e.svg";